isLeadingSurrogate